import React from 'react';
import GoogleButton from 'react-google-button';
import { API_BASE_URL } from '../App';
import { isCostcoChaseHost } from '../lib/productHost';

function OAuthButton({ onBeforeOAuth, mode = 'signin', useApiRedirect = false }) {
  const isLocal = process.env.NODE_ENV === 'development';
  const redirectUri = isLocal ? 'http://localhost:8787/sessions/new' : 'https://api.platechase.com/sessions/new';
  // Local: REACT_APP_* from .env. Production: platechase Google Cloud OAuth client (must match Worker secrets).
  const clientId = isLocal
    ? process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID
    : '127174677252-9kflf91g2mje15d3hu47vh1f3h1283mo.apps.googleusercontent.com';
  const oauthUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=email%20profile&access_type=offline`;
  const label = mode === 'signup' ? 'Sign up with Google' : 'Sign in with Google';

  const handleClick = () => {
    if (onBeforeOAuth) onBeforeOAuth();
    if (useApiRedirect || isCostcoChaseHost()) {
      const returnTo = encodeURIComponent(window.location.origin);
      let url = `${API_BASE_URL}/sessions/new?return_to=${returnTo}`;
      if (isCostcoChaseHost()) url += '&costco=1';
      window.location.href = url;
      return;
    }
    window.location.href = oauthUrl;
  };

  return (
    <div className="oauth-button-container oauth-button-container--labeled">
      <GoogleButton onClick={handleClick} label={label} type="dark" style={{ width: '100%' }} />
    </div>
  );
}

export default OAuthButton;
